// @flow
import React from 'react'
import { useIntl } from 'react-intl'
import Select from 'react-select'
import messages from './messages'
import styles from './genre-dropdown.module.scss'
import { GENRE_LIST } from '@utils/constants'

interface Props {
  value?: string
  onChange: (genre: string) => void
}

const GenreDropdown = ({ value = '', onChange }: Props) => {
  const intl = useIntl()
  const options = GENRE_LIST.map((genre) => ({
    value: genre,
    label: intl.formatMessage(messages[genre]),
  }))
  const selected = options.find((op) => op.value === value)

  return (
    <Select
      className={styles.dropdown}
      classNamePrefix="genre"
      defaultValue={selected}
      aria-label={intl.formatMessage(messages.select)}
      options={options}
      onChange={(d) => onChange(d.value)}
    />
  )
}

export default React.memo(
  GenreDropdown,
  (nextProps, prevProps) => nextProps.value === prevProps.value,
)
